import {SbBlokData, storyblokEditable, useStoryblokApi} from "@storyblok/react";
import {IFeatureItem} from "../../types/IFeatureItem";
import classNames from "classnames";
import {richTextResolver} from "@storyblok/richtext";

type IProps = {
    blok: {
        text: any
    } & SbBlokData
}

export default function InlineParagraph(props: IProps) {
    const blok = props.blok;
    const { render } = richTextResolver()


    return (
        <div className="" {...storyblokEditable(blok)}>
            <div className="rich-text mt-4"
                 dangerouslySetInnerHTML={{
                     __html: render(blok.text) as string
                 }}
            >
            </div>
        </div>

    )
}